var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "182px",
    height: "256px",
    viewBox: "0 0 182 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "html") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "html"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E44D26",
    points: "181.6835 50.1828888 165.1605 234.814724 90.8889999 255.353201 16.822 234.843651 0.3165 50.1828888"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F16529",
    points: "91 239.654465 151.015 223.058003 165.135 65.2816443 91 65.2816443"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBEBEB",
    points: "58.88 110.577911 91 110.577911 91 87.9297773 34.066 87.9297773 34.6095 94.0058869 40.19 156.417301 91 156.417301 91 133.769667 60.955 133.769667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBEBEB",
    points: "63.997 167.741617 41.2045 167.741617 44.3855 203.302044 90.8955 216.180923 91 216.151996 91 192.588681 90.9005 192.615114 65.6135 185.804365"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    points: "17.191 0 28.7295 0 28.7295 11.3711972 39.2845 11.3711972 39.2845 0 50.8235 0 50.8235 34.4347781 39.285 34.4347781 39.285 22.9039851 28.73 22.9039851 28.73 34.4347781 17.1915 34.4347781 17.1915 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    points: "65.997 11.4190759 55.839 11.4190759 55.839 0 87.6989999 0 87.6989999 11.4190759 77.5365002 11.4190759 77.5365002 34.4347781 65.9975 34.4347781 65.9975 11.4190759"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    points: "92.7555002 0 104.787 0 112.188 12.0993528 119.5815 0 131.6175 0 131.6175 34.4347781 120.1265 34.4347781 120.1265 17.3670101 112.188 29.6104978 111.9895 29.6104978 104.0455 17.3670101 104.0455 34.4347781 92.7555002 34.4347781"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    points: "137.36 0 148.902 0 148.902 23.0526087 165.1285 23.0526087 165.1285 34.4347781 137.36 34.4347781"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "90.9214997 156.417301 118.8805 156.417301 116.245 185.789902 90.9214997 192.607633 90.9214997 216.169951 137.4685 203.302044 137.81 199.475736 143.1455 139.851263 143.6995 133.769667 90.9214997 133.769667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "90.9214997 110.522551 90.9214997 110.577911 145.7655 110.577911 146.221 105.487305 147.2555 94.0058869 147.7985 87.9297773 90.9214997 87.9297773"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.652a4e50353621070f432603ffdab734.svg";
export { ForwardRef as ReactComponent };